__turbopack_context__.v({
  "mainPagination": "styles-module-scss-module__S-9WlG__mainPagination",
  "root": "styles-module-scss-module__S-9WlG__root",
});
